<template>
  <div class="product-card">
    <div class="product-card__image">
      <img :src="product.image" :alt="product.name">
    </div>
    <div class="product-card__content">
      <h3 class="product-card__name">{{ product.name }}</h3>
      <p class="product-card__description">{{ product.description }}</p>
      <button class="product-card__btn" @click="goToDetail">了解详情</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToDetail() {
      // 存储产品ID到localStorage，以便ProductDetail组件获取
      localStorage.setItem('productId', this.product.id)
      // 切换到产品详情页面
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'product' }
      }))
    }
  }
}
</script>

<style scoped>
.product-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.product-card__image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.product-card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.product-card:hover .product-card__image img {
  transform: scale(1.05);
}

.product-card__content {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-card__name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.product-card__description {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
  flex: 1;
}

.product-card__btn {
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  align-self: flex-start;
}

.product-card__btn:hover {
  background-color: #0056b3;
}

@media (max-width: 767px) {
  .product-card__image {
    height: 180px;
  }
  
  .product-card__content {
    padding: 15px;
  }
  
  .product-card__name {
    font-size: 16px;
  }
  
  .product-card__description {
    font-size: 13px;
  }
  
  .product-card__btn {
    padding: 8px 16px;
    font-size: 13px;
  }
}
</style>